<template>
  <div class="notification-bell position-relative cursor-pointer" @click="goToNotifications">
    <div class="bell-icon-wrapper p-2 d-flex align-items-center justify-content-center text-secondary hover-primary transition-all">
      <i class="fas fa-bell fa-lg"></i>
      <span v-if="count > 0" class="unread-badge position-absolute bg-danger text-white d-flex align-items-center justify-content-center font-weight-bold">
        {{ displayCount }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationBell',
  props: {
    count: {
      type: Number,
      default: 0
    }
  },
  computed: {
    displayCount() {
      return this.count > 99 ? '99+' : this.count;
    }
  },
  methods: {
    goToNotifications() {
      if (this.$route.name !== 'notifications') {
        this.$router.push({ name: 'notifications' });
      }
    }
  }
}
</script>

